// Packages
import Vue from 'vue';

// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/events/hire-2023.scss';

// Swiper
import Swiper from 'swiper';
import {
  Autoplay,
  Controller,
  EffectFade,
  Navigation as SwiperNavigation,
  Mousewheel as Mousewheel,
} from 'swiper/modules';
Swiper.use([Autoplay, Controller, EffectFade, SwiperNavigation, Mousewheel]);

// Core
import { scrollAnimationProgress } from '~scripts/core/animations';
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Media
const mediaLg = window.matchMedia(`(max-width: ${BREAKPOINTS.lgMax})`);
const mediaMd = window.matchMedia(`(max-width: ${BREAKPOINTS.mdMin})`);
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import '~scripts/blocks/events/forum-2023/modal-video';

// Components
import ParticipateForm from '~scripts/components/vue/forms/ParticipateForm.vue';
import SubscribeForm from '~scripts/components/vue/forms/SubscribeForm.vue';
import initTextAnimation from '~scripts/components/text-animation';

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation(mediaMd);

//
// TEXT ANIMATION
//
initTextAnimation('.js-banner-text-animation');

//
// SPEAKERS SLIDER
//
const speakersSlider = document.querySelector('.js-speakers-slider');

const speakersSliderInit = () => {
  new Swiper(speakersSlider, {
    speed: 600,
    slidesPerView: 'auto',
    loop: true,
    centeredSlides: !mediaSm.matches,
    spaceBetween: mediaSm.matches ? 24 : 32,
    grabCursor: true,
    navigation: {
      nextEl: '.js-speakers-slider .swiper-button-next',
      prevEl: '.js-speakers-slider .swiper-button-prev',
    },
    mousewheel: {
      forceToAxis: true,
    },
    on: {
      init: function () {
        if (!mediaSm.matches) {
          this.slideNext();
        }
      },
    },
  });
};

speakersSliderInit();
mediaSm.addEventListener('change', speakersSliderInit);

//
// BONUSES
//
let bonusesListSlider = null;

const bonusesListSliderInit = () => {
  if (!mediaLg.matches && bonusesListSlider) {
    bonusesListSlider.destroy();
  } else {
    bonusesListSlider = new Swiper('.js-bonuses-list-slider', {
      slidesPerView: 'auto',
      speed: 600,
      slideToClickedSlide: true,
    });
  }
};

bonusesListSliderInit();
mediaSm.addEventListener('change', bonusesListSliderInit);

const bonusesList = document.querySelector('.js-bonuses-list');
const bonusesListEl = bonusesList.querySelectorAll('li');
const bonusesNav = document.querySelectorAll('.js-bonuses-nav');

bonusesListEl.forEach((el, index) => {
  el.addEventListener('click', () => {
    bonusesSlider.slideTo(index, 600);
    bonusesSlider.autoplay.stop();
    setTimeout(() => {
      bonusesSlider.autoplay.start();
    }, 10);
  });
});

bonusesNav.forEach((element) => {
  element.addEventListener('click', (e) => {
    const isNextButtonDisabled =
      e.target.classList.contains('swiper-button-next') && e.target.classList.contains('swiper-button-disabled');

    if (isNextButtonDisabled) {
      setTimeout(() => {
        bonusesSlider.slideTo(0, 600);
      }, 10);
    }
  });
});

const bonusesSlider = new Swiper('.js-bonuses', {
  effect: 'fade',
  autoplay: {
    disableOnInteraction: false,
    delay: 5000,
  },
  fadeEffect: {
    crossFade: true,
  },
  speed: 600,
  slidesPerView: 'auto',
  spaceBetween: 0,
  grabCursor: true,
  navigation: {
    nextEl: '.bonuses .swiper-button-next',
    prevEl: '.bonuses .swiper-button-prev',
  },
  on: {
    init() {
      bonusesListEl[0].classList.add('active');
    },
    slideChange() {
      let index = this.realIndex;
      bonusesListEl.forEach((element) => {
        element.classList.remove('active');
      });

      if (bonusesListSlider) {
        bonusesListSlider.slideTo(index, 600);
      }
      bonusesListEl[index].classList.add('active');
    },
  },
});

bonusesListSlider.control = bonusesSlider;

//
// CHARITY SLIDER
//
let charitySlider = null;

const charitySliderInit = () => {
  if (!mediaSm.matches && charitySlider !== null) {
    charitySlider.destroy();
  } else {
    charitySlider = new Swiper('.js-charity-mobile-slider', {
      slidesPerView: 'auto',
      speed: 600,
      spaceBetween: 24,
    });
  }
};

charitySliderInit();
mediaSm.addEventListener('change', charitySliderInit);

let stopCharityScrollAnimation = null;

const handleCharityPhotoAnimation = () => {
  const charityAnimation = document.querySelector('.js-charity');

  if (mediaSm.matches) {
    if (stopCharityScrollAnimation && typeof stopCharityScrollAnimation === 'function') {
      stopCharityScrollAnimation();
    }
  } else {
    stopCharityScrollAnimation = scrollAnimationProgress(charityAnimation, {
      getStart(el) {
        const rect = el.getBoundingClientRect();

        return rect.top + window.scrollY - window.innerHeight;
      },
      getEnd(el, start) {
        return start + el.offsetHeight;
      },
    });
  }
};

handleCharityPhotoAnimation();
mediaSm.addEventListener('change', handleCharityPhotoAnimation);

//
// PHOTO SLIDER
//
const photoSlider = document.querySelector('.js-photo-slider');

new Swiper(photoSlider, {
  speed: 600,
  slidesPerView: 'auto',
  loop: true,
  centeredSlides: true,
  spaceBetween: 0,
  grabCursor: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  mousewheel: {
    forceToAxis: true,
  },
  on: {
    afterInit: function () {
      this.slideTo(3, 10);
    },
  },
});

//
// PLACE SLIDER
//
const placeSlider = document.querySelector('.js-place-slider');

new Swiper(placeSlider, {
  speed: 600,
  slidesPerView: 'auto',
  loop: true,
  centeredSlides: true,
  spaceBetween: 0,
  grabCursor: true,
  navigation: {
    nextEl: '.js-place-slider .swiper-button-next',
    prevEl: '.js-place-slider .swiper-button-prev',
  },
  mousewheel: {
    forceToAxis: true,
  },
  on: {
    afterInit: function () {
      this.slideTo(3, 10);
    },
  },
});

//
// FORM
//
const formWrappers = document.querySelectorAll('.js-form-wrapper');

formWrappers.forEach(formWrap => {
  const formName = formWrap.dataset.form;
  const component = formName === 'SubscribeForm' ? SubscribeForm : ParticipateForm;

  new Vue({
    el: formWrap,
    components: {
      [formName]: component,
    },
  });
});
